import { withInstall } from '@klondpay/utils';
import reNormalCountTo from './src/normal';
import reboundCountTo from './src/rebound';
/** 回弹式数字动画组件 */
export const ReboundCountTo = withInstall(reboundCountTo);
/** 普通数字动画组件 */
export const ReNormalCountTo = withInstall(reNormalCountTo);
